import { useContext } from "react";

import { AgenticAiChatInterfaceWidthContext } from "@lib/AgenticAiChatInterfaceWidthContext";

export const useAgenticAiChatInterfaceWidthContext = () => {
  return useContext(AgenticAiChatInterfaceWidthContext);
};
